import Vue from 'vue'
import { Select } from 'ant-design-vue'
import { savePreviousData } from '@/services/api'
import { showNotification } from '@/services/calculate'
import _ from 'lodash'

Vue.use(Select)

export default Vue.extend({
  template: `
    <div class="a-gcell">
      <a-select
        show-search
        :allowClear="dropdownName !== 'templateBuildingUse' && Boolean(value)"
        size="small"
        placeholder="Select"
        v-model="value"
        style="width: 100%;"
        @change="handleChange"
        @focus="savePreviousData(value)"
        @dropdownVisibleChange="openDropdown"
        :dropdownStyle="{
          minWidth: 'auto !important',
          overflow: 'auto !important'
        }"

        :disabled="params.data.linkMethod === 1 || (dropdownName === 'template' && params.data.analysisTypeId === 2)"
      >
        <a-select-option value="none" v-if="params.value && dropdownName === 'template'">
          <a-tooltip title="None" placement="left">
            None
          </a-tooltip>
        </a-select-option>
        <a-select-option v-for="item in list" :value="item.option" :key="item.id">
          {{ item.option }}
        </a-select-option>
      </a-select>
    </div>
    `,

  data() {
    return {
      list: [],
      value: undefined,
      savePreviousData: savePreviousData,
      showDropdown: true,
      isChange: false,
      dropdownName: undefined,
    }
  },
  beforeMount() {
    this.showDropdown = true
    const data = this.params.colDef.cellRendererParams.dropdownData
    this.dropdownName = this.params.colDef.cellRendererParams.dropdownName
    switch (this.dropdownName) {
      case 'template':
        this.loadingData = true
        this.list = this.params.colDef.cellRendererParams.templates
          .filter(
            i =>
              i.analysis_Type_Id === this.params.data.analysisTypeId &&
              i.structure_Profile_Id === this.params.data.structureProfileId &&
              i.building_Use === this.params.data.buildingUse,
          )
          .map(x => {
            x.option = x.template_Name
            return x
          })
        this.loadingData = false
        break
      case 'tempBuildingUse':
        if (this.params.colDef.cellRendererParams.type === 'projectDetails') {
          this.list = data.tempBuildingUse.filter(
            i => i.structureProfileId === this.params.data.structureProfileId,
          )
        }
        break
      case 'templateBuildingUse':
        if (this.params.colDef.cellRendererParams.type === 'template') {
          this.list = data.temp_building_use.filter(
            i => i.structureProfileId === this.params.data.structureProfileId,
          )
        }
        break
      default:
        this.list = data[this.dropdownName]
        break
    }
  },
  created() {
    this.value = _.get(this.params, 'value', undefined)
  },
  methods: {
    handleChange(value) {
      switch (this.params.colDef.cellRendererParams.type) {
        case 'projectDetails':
          switch (this.params.colDef.field) {
            case 'template':
              const templateDetails = this.list.find(i => i.option === value)
              if (this.params.value) {
                var that = this
                this.$confirm({
                  title: `Are you sure want to change template?`,
                  content: h => (
                    <div style="color:red">
                      <p>
                        This action will delete all tenants and data related to
                        this asset:{'  '}
                        {that.params.data.description ||
                          that.params.data.assetNumber}
                        .
                      </p>
                      <p>Please confirm.</p>
                    </div>
                  ),
                  onOk() {
                    that.value = value
                    that.$root.$emit(
                      'applyTemplate',
                      value || 'none',
                      that.params.data,
                      that.params.colDef.field,
                      that.params.rowIndex,
                      templateDetails,
                      null,
                      false,
                    )
                  },
                  onCancel() {
                    that.value = that.params.value
                  },
                })
              } else {
                this.$root.$emit(
                  'applyTemplate',
                  value || 'none',
                  this.params.data,
                  this.params.colDef.field,
                  this.params.rowIndex,
                  templateDetails,
                  null,
                  true,
                )
              }
              break
            case 'analysisType':
            case 'structureProfile':
            case 'buildingUse':
              const typeDetails = this.list.find(i => i.option === value)
              if (this.params.value) {
                var self = this
                this.$confirm({
                  title: `Are you sure want to change ${this.params.colDef.headerName.toLowerCase()}?`,
                  content: h => (
                    <div style="color:red">
                      <p>
                        This action will change all information related this
                        asset.
                      </p>
                      <p>Please confirm.</p>
                    </div>
                  ),
                  onOk() {
                    self.value = value
                    self.$root.$emit(
                      'updateAssetsDetails',
                      value || 'none',
                      self.params.data,
                      self.params.colDef.field,
                      self.params.rowIndex,
                      typeDetails,
                    )
                  },
                  onCancel() {
                    self.value = self.params.value
                  },
                })
              } else {
                this.$root.$emit(
                  'updateAssetsDetails',
                  value || 'none',
                  this.params.data,
                  this.params.colDef.field,
                  this.params.rowIndex,
                  typeDetails,
                )
              }
              break
            default:
              break
          }
          break
        case 'AnalysisSheet':
          const factor = this.list.find(i => i.option === value)
          this.$root.$emit(
            'saveAnalysisData',
            value,
            this.params.data,
            this.params.colDef.field,
            this.params.rowIndex,
            null,
            factor,
          )
          break
        case 'template':
          switch (this.params.colDef.field) {
            case 'buildingUse':
              if (this.params.value) {
                value = value ? this.list.find(i => i.option === value).id : ''
                this.$root.$emit(
                  'updateTemplateBuildingUse',
                  this.params.data,
                  value || null,
                  this.params.colDef.field,
                )
              }
          }
          break
        default:
          break
      }
    },

    openDropdown(open) {
      if (open && this.dropdownName === 'template' && this.list.length === 0) {
        showNotification(
          'info',
          'Template',
          'There are no templates published yet. Please publish the template to see the list.',
        )
      }
    },

    getValue() {
      return this.value
    },
  },
})
